import { render, staticRenderFns } from "./ModattaHowItWorks.vue?vue&type=template&id=56003d30"
import script from "./ModattaHowItWorks.vue?vue&type=script&lang=js"
export * from "./ModattaHowItWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports